@if (viewModel$ | async; as vm) {
	<bci-wk-alert bci-info [btnClose]="false" class="phone-alert">
		Recuerda que para verificar tu identidad, te llamaremos desde un número 600 XXX XXXX.
	</bci-wk-alert>

	<section class="container flex">
		<div class="container-left flex">
			<div class="wrap-company-data flex">
				<div>
					<p class="subtitle text" [innerHTML]="vm.parameters.subtitle"></p>
				</div>
				<div>
					<p class="paragraph text" [innerHTML]="vm.parameters.content"></p>
				</div>
				<div class="wrap-form flex">
					<form [formGroup]="companyDataForm">
						<bci-wk-input-text
							[placeholder]="'Ej: 77777777-7'"
							[label]="'Rut empresa'"
							formControlName="companyRut"
							class="input"
							appRutFormatter
							[ngClass]="companyRutControl.touched ? 'ng-dirty' : ''"
						>
							<bci-form-msg *ngIf="companyRutControl.invalid && companyRutControl.touched">
								Ingresa un RUT de empresa válido
							</bci-form-msg>
						</bci-wk-input-text>

						<bci-wk-input-text
							*ngIf="userRutControl"
							[placeholder]="'Ej: 77777777-7'"
							[label]="'Rut usuario'"
							formControlName="userRut"
							class="input"
							appRutFormatter
							[ngClass]="userRutControl.touched ? 'ng-dirty' : ''"
						>
							<bci-form-msg *ngIf="userRutControl.invalid && userRutControl.touched">
								Ingresa un RUT de usuario válido
							</bci-form-msg>
						</bci-wk-input-text>

						<bci-wk-input-phone
							formControlName="phoneNumber"
							[placeholder]="'99999999'"
							[label]="'Teléfono'"
							[oneAreaCode]="'9'"
							class="input"
							appValidatePhone
						>
							<bci-form-msg *ngIf="phoneControl.invalid && phoneControl.touched">
								Ingresa un teléfono válido
							</bci-form-msg>
						</bci-wk-input-phone>

						<bci-wk-input-text
							[placeholder]="'Ingresa un mail'"
							[label]="'Email'"
							[type]="'email'"
							formControlName="email"
							class="input"
							[ngClass]="emailControl.touched ? 'ng-dirty' : ''"
						>
							<bci-form-msg *ngIf="emailControl.invalid && emailControl.touched">
								Ingresa un correo electrónico válido
							</bci-form-msg>
						</bci-wk-input-text>

						<bci-wk-select
							formControlName="salesLevel"
							[placeholder]="'¿Cuál es tu nivel de ventas anual?'"
							[text]="'Ingresa nivel de ventas'"
							class="input"
						>
							<option *ngFor="let item of vm.parameters.salesLevels" [value]="item.level">
								{{ item.range }}
							</option>
						</bci-wk-select>

						<div formGroupName="privacyTerms">
							<div class="flex wrap-privacy-terms">
								@for (purpose of vm.activePurposes; track purpose.id) {
									<div class="purpose flex">
										<bci-wk-checkbox class="checkbox" [formControlName]="purpose.id"></bci-wk-checkbox>
										<div class="text privacy-terms" [innerHTML]="purpose.description"></div>
									</div>
								}
							</div>
						</div>
					</form>
				</div>
			</div>
			<div class="wrap-buttons flex">
				<button
					bciWkButtonPrimary
					(click)="onSendDataForValidation(vm.parameters, vm.idForm)"
					[disabled]="companyDataForm.invalid"
				>
					Continuar
				</button>
			</div>
		</div>

		<div class="container-right flex">
			<div class="wrap-info-simulation flex">
				<div class="wrap-title flex">
					<img class="monologue" src="assets/images/monologue-blue.svg" alt="monologue" />
					<p class="title-simulation">Información de tu simulación</p>
				</div>
				<div class="container-requirements">
					<div class="wrap-requirements flex">
						<img src="assets/images/ico-information.svg" alt="information icon" />
						<p class="text">
							Te pediremos algunos datos de tu empresa e información financiera, que
							<b>usaremos solo para esta simulación</b>.
						</p>
					</div>
					<div class="wrap-requirements flex">
						<img src="assets/images/ico-mobile.svg" alt="mobile icon" />
						<p class="text">
							Debes tener tu celular cerca, pronto te pediremos verificar tu identidad por
							<strong>SMS</strong> y te llamaremos desde un número <br />
							<strong>600 XXX XXXX</strong>.
						</p>
					</div>
					<div class="wrap-requirements flex">
						<img src="assets/images/ico-thumb-up.svg" alt="thumb up icon" />
						<p class="text">
							Simula con tranquilidad. Esto es solo una referencia y no genera ningún compromiso. Si ya
							eres cliente, te sugerimos hacerlo desde tu Banco en Línea.
						</p>
					</div>
					<div class="wrap-requirements flex">
						<img src="assets/images/ico-help-contact.svg" alt="help contact icon" />
						<p class="text">
							Al finalizar la simulación, un ejecutivo te contactará para ayudarte con los siguientes
							pasos.
						</p>
					</div>
				</div>
			</div>
			@if (showWhatsappBtn) {
				<div class="wrap-whatsapp-contact flex">
					<app-whatsapp-contact></app-whatsapp-contact>
				</div>
			}
		</div>
	</section>
}
